import React, { Fragment, useCallback, useState } from 'react';
import EngineAttributeContainer from './EngineAttributeContainer';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { getInt } from '../../../../utils/functions';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_SCORING } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const [title, setTitle] = useState('');
  const match = useRouteMatch();

  const id = match.params.id && getInt(match.params.id);

  const onClickClose = () => {
    historyContext.push(`/engineAttributes`);
  };

  const onChangeTitle = engineAttributeTitle => {
    setTitle(engineAttributeTitle);
  };

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/engineAttributes/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SCORING}>
        <EngineAttributeContainer id={id} onChangeTitle={onChangeTitle} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
